// 9fbef606107a605d69c0edbcd8029e5d

const drawGift = (ctx, size, colors) => {
  const boxWidth = size;
  const boxHeight = size;
  const ribbonWidth = size * 0.15;

  // Draw the gift box (base)
  ctx.fillStyle = colors;
  ctx.fillRect(0, 0, boxWidth, boxHeight);

  // Draw vertical ribbon
  ctx.fillStyle = ' #000000';
  ctx.fillRect(boxWidth / 2 - ribbonWidth / 2, 0, ribbonWidth, boxHeight);

  // Draw horizontal ribbon
  ctx.fillRect(0, boxHeight / 2 - ribbonWidth / 2, boxWidth, ribbonWidth);

  // Draw bow (simple cross bow)
  ctx.beginPath();
  ctx.moveTo(boxWidth / 2, 0);
  ctx.lineTo(boxWidth / 2 - ribbonWidth, -ribbonWidth);
  ctx.lineTo(boxWidth / 2, -ribbonWidth * 1.5);
  ctx.lineTo(boxWidth / 2 + ribbonWidth, -ribbonWidth);
  ctx.closePath();
  ctx.fill();

  ctx.beginPath();
  ctx.arc(boxWidth / 2, 0, ribbonWidth / 2, 0, Math.PI * 2);
  ctx.fill();
};;;;

export default drawGift;
